'use client'

import React, { useState, useEffect } from 'react'
import Image from 'next/image'
import { useTheme } from '@/app/[locale]/ThemeProvider'

interface NavigationLogoProps {
  siteName: string
  siteLogo: string
  darkModeLogo?: string
}

export default function NavigationLogo({ 
  siteName, 
  siteLogo, 
  darkModeLogo 
}: NavigationLogoProps) {
  const { theme } = useTheme()
  const [mounted, setMounted] = useState(false)
  
  // Mark component as mounted to avoid hydration mismatch
  useEffect(() => {
    setMounted(true)
  }, [])
  
  // During SSR and initial render, default to dark mode logo to match ThemeProvider's SSR default
  // This prevents the flash when the page loads
  const logoSrc = (!mounted || theme === 'dark') && darkModeLogo ? darkModeLogo : siteLogo
  
  return (
    <Image 
      src={logoSrc} 
      alt={siteName} 
      width={60}
      height={60}
      className="w-24 h-24 lg:w-28 lg:h-28 object-contain" 
      priority
    />
  )
} 